<template>
  <div>
    <div class="heading-travel-policy">
      <span :class="domesticAirFareCapObj.isActive ? 'tag is-success' : 'tag'"
        >Standard</span
      >

      <div class="right-content">
        <div class="lefttext">
          <p class="paragrapgh">Domestic airfare cap</p>
          <p>
            Trigger for any flight within the U.S. when the total cost is above
            <span class="rule-config-variable" @click="isEdit = !isEdit"
              >{{
                domesticAirFareCapObj.value
                  ? "$" + domesticAirFareCapObj.value
                  : "N/A"
              }}

              <b-icon icon="pencil" size="is-small"></b-icon>
            </span>
          </p>
        </div>
        <div class="allbtns">
          <!-- <button @click="isEdit = !isEdit"><u v-if="!isEdit">EDIT</u><u v-if="isEdit">CANCEL</u></button> -->
          <b-switch
            :rounded="true"
            :value="domesticAirFareCapObj.isActive"
            v-model="domesticAirFareCapObj.isActive"
            @input="domesticAirfareCap"
          >
          </b-switch>
        </div>
      </div>
    </div>

    <div v-if="isEdit" class="edittravelpolicy">
      <DomesticAirFareCap
        @domesticAirFareCap="getValue"
        :demesticAirFare="domesticAirFareCapObj.value"
      />
      <p>Enter amount</p>
      <b-button @click="saveCall">SAVE</b-button>
    </div>
  </div>
</template>
<script>
import DomesticAirFareCap from "../CommonRules/DomesticAirFareCap.vue";

export default {
  name: "",
  components: { DomesticAirFareCap },
  props: {
    value: {
      type: [Object],
    },
  },
  data() {
    return {
      domesticAirFareCapObj: this.value
        ? this.value
        : {
            name: "domesticAirfareCap",
            isActive: false,
            value: 500,
            type: "air",
            message: "",
          },
      isEdit: false,
      emitedValue: null,
    };
  },
  methods: {
    saveCall() {
      this.isEdit = false;
      if (this.emitedValue || this.emitedValue == "") {
        this.domesticAirFareCapObj.value = this.emitedValue;
      }
    },
    getValue(val) {
      this.emitedValue = val;
    },
    domesticAirfareCap() {
      this.domesticAirFareCapObj.message = this.buildMessage;
      this.$emit("domesticAirfareCap", this.domesticAirFareCapObj);
    },
  },
  mounted() {
    this.domesticAirFareCapObj.type = "air";
    this.domesticAirFareCapObj.message = this.buildMessage;

    this.$emit("domesticAirfareCap", this.domesticAirFareCapObj);
  },
  computed: {
    buildMessage() {
      var string =
        "Trigger for any flight within the U.S. when the total cost is above";

      return (
        string +
        (this.domesticAirFareCapObj.value
          ? " $" + this.domesticAirFareCapObj.value
          : "N/A")
      );
    },
  },
  watch: {
    value: {
      handler(newVal, prevVal) {
        this.domesticAirFareCapObj = this.value;
        this.domesticAirFareCapObj.type = "air";
    this.domesticAirFareCapObj.message = this.buildMessage;
        this.$emit("domesticAirfareCap", this.domesticAirFareCapObj);

      },
      deep: true,
    },
  },
};
</script>
